function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { uniq } from 'lodash';
import { ZodError, z } from 'zod';
import { FormDefinition, TimelessDateString, FileInfoSchema } from "./DynamicForm.types";
import { attachDataToError } from '@applyboard/ui-utils';

/**
 * Anytime a field is hidden we want to clear its value.  Due to the fact that
 * we support conditional logic in our form for hiding and showing fields based
 * on other field values, this can cause a chain reaction where by hiding one
 * field, we need to hide and clear the values of several other fields
 *
 * This function goes through that chain reaction and clears the values of any
 * fields that are about to be hidden
 *
 * It doesn't actually hide the fields themselves, it just clears the values.
 * This is because the actual "hiding/showing" is covered during rendering.
 *
 * It also does the opposite when fields are shown, however instead of
 * "clearing" the field, it sets the value to the default value for that field
 */
export function calculateOtherFieldValueUpdates(_ref) {
  var value = _ref.value,
    oldValues = _ref.oldValues,
    component = _ref.component,
    dependencyGraph = _ref.dependencyGraph,
    formDefinition = _ref.formDefinition,
    initialLoad = _ref.initialLoad;
  var newValues = _objectSpread(_objectSpread({}, oldValues), {}, _defineProperty({}, component.key, value));
  var allDependencies = dependencyGraph[component.key] || [];
  var _iterator = _createForOfIteratorHelper(allDependencies),
    _step;
  try {
    var _loop = function _loop() {
      var dependencyKey = _step.value;
      var dependentComponent = formDefinition.components.filter(isFieldComponent).find(function (el) {
        return el.key === dependencyKey;
      });
      if (!(dependentComponent !== null && dependentComponent !== void 0 && dependentComponent.conditional)) {
        return 1; // continue
      }
      var wasShowingPreviously = decideShouldShowField(dependentComponent, oldValues);
      var shouldShowField = decideShouldShowField(dependentComponent, newValues);
      if (!shouldShowField) {
        if (wasShowingPreviously || initialLoad) {
          newValues[dependencyKey] = getEmptyValue(dependentComponent.type);
        }
      } else {
        // So we don't over-write what the user was typing, lets only reset the
        // field to its default when it transitions from hidden to shown.  Let's
        // not reset the value if the field was already shown
        if ((!wasShowingPreviously || initialLoad) && typeof dependentComponent.defaultValue !== 'undefined') {
          newValues[dependencyKey] = dependentComponent.defaultValue;
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }

    // Don't bother returning the new value of the currently component, since
    // updating the current field is handled by the form abstraction already.
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  delete newValues[component.key];
  return newValues;
}

/**
 * Gets the "empty" value for a particular component type.  Typically this is an
 * empty string, but for some fields (like file uploads) it could be an empty
 * array instead
 */
function getEmptyValue(componentType) {
  // switch statement must explicitly exhaustively handle all component types or there
  // will be a TS error above
  switch (componentType) {
    case 'file':
    case 'selectboxes':
      return [];
    case 'checkbox':
      return false;
    case 'day':
    case 'number':
    case 'radio':
    case 'select':
    case 'textarea':
    case 'textfield':
    case 'htmlelement':
    case 'paymentframe':
    case 'paymentprompt':
      return '';
  }
}

/**
 * Gets the direct dependencies of a component.  In other words, gets the field
 * keys for fields that when changed could impact the visibility of the current
 * field.
 *
 * Keep in mind this is different from direct + transitive dependencies, which
 * would include components that could cause a chain reaction that hides this
 * field.  Direct + transitive dependencies are calculated by
 * `buildConditionalLogicDependencyGraph`
 *
 * @param component The component information as specified in the form definition
 */
export function getConditionalLogicDirectDependencies(component) {
  var _component$conditiona;
  var conditionalComponents = ((_component$conditiona = component.conditional) === null || _component$conditiona === void 0 ? void 0 : _component$conditiona.conditions.map(function (condition) {
    return condition.component;
  })) || [];
  return uniq(conditionalComponents);
}

/**
 * Evaluates the conditional logic on a field and decides whether or not to show the field
 *
 * @param component The component information as specified in the form definition
 * @param values The current field values for all fields in the form
 */
export function decideShouldShowField(component, values) {
  if (!component.conditional) {
    return true;
  }
  return component.conditional.conjunction === 'all' ? component.conditional.conditions.every(function (condition) {
    return evaluateCondition(condition, values);
  }) : component.conditional.conditions.some(function (condition) {
    return evaluateCondition(condition, values);
  });
}
function evaluateCondition(condition, values) {
  switch (condition.operator) {
    case 'isEqual':
      return condition.value === values[condition.component];
    case 'isNotEqual':
      return condition.value !== values[condition.component];
    case 'isEmpty':
      {
        return isEmptyValue(values[condition.component]);
      }
    case 'isNotEmpty':
      {
        return !isEmptyValue(values[condition.component]);
      }
  }
}
export function isEmptyValue(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (typeof value === 'string') {
    return !value.trim();
  }
  return !value;
}

/**
 * Calculates / constructs the conditional logic dependency graph for the form definition
 *
 * It returns an object like this:
 * ```
 * {
 *   doYouWantIceCream: ["whatFlavour", "areYouSure"],
 *   whatFlavour: ["areYouSure"],
 *   areYouSure: []
 * }
 * ```
 * For each key in this object, its value is an array of all the fields whose
 * visibility may be impacted if the field with the given key changes
 *
 * It not only includes fields that are directly impacted, but also indirectly
 * impacted.  Changing the first field may cause a chain reaction, where the act
 * of earlier fields in the array hiding causes later fields in the array to
 * hide as-well
 *
 * @param formDefinition The formDefinition that describes the structure of the form
 */
export function buildConditionalLogicDependencyGraph(formDefinition) {
  var dependencyGraph = {};
  var _iterator2 = _createForOfIteratorHelper(formDefinition.components),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var component = _step2.value;
      dependencyGraph[component.key] = recursivelyGetDependencies(component, formDefinition);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return dependencyGraph;
}
function recursivelyGetDependencies(component, formDefinition) {
  var dependencies = [];
  var _iterator3 = _createForOfIteratorHelper(formDefinition.components),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _possiblyDependentCom;
      var possiblyDependentComponent = _step3.value;
      if ((_possiblyDependentCom = possiblyDependentComponent.conditional) !== null && _possiblyDependentCom !== void 0 && _possiblyDependentCom.conditions.find(function (c) {
        return c.component === component.key;
      })) {
        dependencies.push(possiblyDependentComponent.key);
        dependencies = dependencies.concat(recursivelyGetDependencies(possiblyDependentComponent, formDefinition));
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return dependencies;
}

/**
 * Gets which page the component should be viewed on
 *
 * @param component The component information as specified in the form definition
 */
export function getComponentPage(component) {
  var _component$properties;
  return typeof ((_component$properties = component.properties) === null || _component$properties === void 0 ? void 0 : _component$properties.page) === 'string' ? Number(component.properties.page) : 1;
}

/**
 * Validates whether 'formData' values matches the accepted values of the 'formDefinition'
 * Returns a parsed version of the 'formData'
 */
export function validateFormDataAgainstFormDefinition(formDefinition, formData) {
  var parsedFormData = {};
  var _loop2 = function _loop2(key) {
    var component = formDefinition.components.find(function (component) {
      return component.key === key;
    });
    if (!component) {
      throw new Error('Could not find component with matching formdata key');
    }
    parsedFormData[key] = parseFieldValue(formData[key], component.type);
  };
  for (var key in formData) {
    _loop2(key);
  }
  return parsedFormData;
}
function parseFieldValue(value, componentType) {
  switch (componentType) {
    case 'textfield':
    case 'radio':
    case 'select':
    case 'number':
    case 'textarea':
      return z.string().parse(value);
    case 'day':
      return TimelessDateString.parse(value);
    case 'checkbox':
      return z["boolean"]().parse(value);
    case 'selectboxes':
      return z.string().array().nullable().transform(function (value) {
        return value === null ? [] : value;
      }).parse(value);
    case 'file':
      // For some reason, if the FE sends an empty array in the form_data PATCH request, the BE returns null
      // The .transform() is being used to here to convert null to an empty array when this occurs
      return z.union([z.string(), FileInfoSchema]).array().nullable().transform(function (value) {
        return value === null ? [] : value;
      }).parse(value);
    case 'htmlelement':
    default:
      return z.undefined().parse(value);
  }
}

/**
 * Copies the default values from the "formData" object onto the formDefinition.
 * This is needed because our logic uses the "default" property on the
 * formDefinition
 *
 * @note This function will throw an error if the type of a value in formData
 * does not match up with the type of the field in the form definition
 *
 * @param formDefinition The form definition that describes the structure of the form
 * @param formData The key-value pairs of default values, where each key is the field name and the value is its default
 * @returns A form definition with potentially more default values
 */
export function copyFormDataOntoFormDefinition(formDefinition, formData) {
  return {
    components: formDefinition.components.map(function (component) {
      if (typeof formData[component.key] === 'undefined') {
        return component;
      }

      // switch statement must exhaustively handle all component types or there
      // will be a TS error above
      switch (component.type) {
        case 'day':
          return _objectSpread(_objectSpread({}, component), {}, {
            defaultValue: TimelessDateString.parse(formData[component.key])
          });
        case 'file':
          // For some reason, if the FE sends an empty array in the form_data PATCH request, the BE returns null
          // The .transform() is being used to here to convert null to an empty array when this occurs
          return _objectSpread(_objectSpread({}, component), {}, {
            defaultValue: z.union([z.string(), FileInfoSchema]).array().nullable().transform(function (value) {
              return value === null ? [] : value;
            }).parse(formData[component.key])
          });
        case 'textfield':
          return _objectSpread(_objectSpread({}, component), {}, {
            defaultValue: z.string().parse(formData[component.key])
          });
        case 'radio':
          return _objectSpread(_objectSpread({}, component), {}, {
            defaultValue: z.string().parse(formData[component.key])
          });
        case 'select':
          return _objectSpread(_objectSpread({}, component), {}, {
            defaultValue: z.string().parse(formData[component.key])
          });
        case 'number':
          return _objectSpread(_objectSpread({}, component), {}, {
            defaultValue: z.string().parse(formData[component.key])
          });
        case 'textarea':
          return _objectSpread(_objectSpread({}, component), {}, {
            defaultValue: z.string().parse(formData[component.key])
          });
        case 'checkbox':
          return _objectSpread(_objectSpread({}, component), {}, {
            defaultValue: z["boolean"]().parse(formData[component.key])
          });
        case 'selectboxes':
          return _objectSpread(_objectSpread({}, component), {}, {
            defaultValue: z.string().array().nullable().transform(function (value) {
              return value === null ? [] : value;
            }).parse(formData[component.key])
          });
        case 'paymentframe':
        case 'paymentprompt':
        case 'htmlelement':
          return component;
      }
    })
  };
}

/**
 * Calculates the initial default values to be passed to <Form />, based off the
 * form definition.  Takes into account show/hide logic.  For example, if a
 * field should be currently hidden, then the "default" value for this field
 * when passed to <Form /> should be an empty string, even if it has a "default"
 * configured in formData or formDefinition
 */
export function calculateInitialDefaultValues(_ref2) {
  var formDefinition = _ref2.formDefinition,
    dependencyGraph = _ref2.dependencyGraph;
  var defaultValues = getDefaultValuesFromFormDefinition(formDefinition.components);
  var fieldComponents = formDefinition.components.filter(isFieldComponent);
  var _iterator4 = _createForOfIteratorHelper(fieldComponents),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var component = _step4.value;
      var updates = calculateOtherFieldValueUpdates({
        value: defaultValues[component.key] || getEmptyValue(component.type),
        component: component,
        dependencyGraph: dependencyGraph,
        formDefinition: formDefinition,
        oldValues: defaultValues,
        initialLoad: true
      });
      defaultValues = _objectSpread(_objectSpread({}, defaultValues), updates);
    }

    // Fill in empty values for the remaining fields
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  var _iterator5 = _createForOfIteratorHelper(fieldComponents),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _component = _step5.value;
      if (!(_component.key in defaultValues)) {
        defaultValues[_component.key] = getEmptyValue(_component.type);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return defaultValues;
}

/**
 * Returns the default values of a form as defined in the formDef
 */
function getDefaultValuesFromFormDefinition(components) {
  var defaultValues = {};
  var _iterator6 = _createForOfIteratorHelper(components),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var component = _step6.value;
      if (isFieldComponent(component) && component.defaultValue) {
        defaultValues[component.key] = component.defaultValue;
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return defaultValues;
}

/**
 * Parses the formDef and ensures it has the expected shape.  Throws an error if
 * the passed in data is not a FormDefinition
 */
export function parseFormDef(unknownFormDef) {
  try {
    var parsedFormDef = FormDefinition.parse(unknownFormDef);
    var keys = parsedFormDef.components.map(function (component) {
      return component.key;
    });
    var uniqueKeys = uniq(keys);
    if (keys.length !== uniqueKeys.length) {
      throw new Error('formDefinition was corrupt, found multiple components with the same key');
    }
    return parsedFormDef;
  } catch (err) {
    if (err instanceof ZodError) {
      attachDataToError(err, unknownFormDef);
    }
    throw err;
  }
}
export function checkAreAnyFieldsVisible(_ref3) {
  var currentPage = _ref3.currentPage,
    formDefinition = _ref3.formDefinition,
    fieldValues = _ref3.fieldValues;
  return formDefinition.components.filter(function (component) {
    return decideShouldShowField(component, fieldValues);
  }).some(function (component) {
    return getComponentPage(component) === currentPage;
  });
}
export function getNextPageWithVisibleFields(_ref4) {
  var currentPage = _ref4.currentPage,
    formDefinition = _ref4.formDefinition,
    fieldValues = _ref4.fieldValues;
  var newPage = null;
  var _iterator7 = _createForOfIteratorHelper(formDefinition.components),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var component = _step7.value;
      var componentPage = getComponentPage(component);
      if (decideShouldShowField(component, fieldValues) && (newPage === null || componentPage < newPage) && componentPage > currentPage) {
        newPage = componentPage;
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  if (newPage === null) {
    return currentPage + 1;
  }
  return newPage;
}
export function getPrevPageWithVisibleFields(_ref5) {
  var currentPage = _ref5.currentPage,
    formDefinition = _ref5.formDefinition,
    fieldValues = _ref5.fieldValues;
  var newPage = null;
  var _iterator8 = _createForOfIteratorHelper(formDefinition.components),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var component = _step8.value;
      var componentPage = getComponentPage(component);
      if (decideShouldShowField(component, fieldValues) && (newPage === null || componentPage > newPage) && componentPage < currentPage) {
        newPage = componentPage;
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  return newPage;
}
export function isFieldComponent(component) {
  return component.type !== 'htmlelement' && component.type !== 'paymentprompt' && component.type !== 'paymentframe';
}
export function isPreviewableComponent(component) {
  return component.type === 'file' || component.type === 'paymentframe';
}
export function isReceiptComponent(component) {
  return (component === null || component === void 0 ? void 0 : component.type) === 'paymentframe';
}
export function isFileInfo(value) {
  return _typeof(value) === 'object' && typeof value.id === 'string' && value.file instanceof File;
}
export function canUploadFiles(formDefinition) {
  return formDefinition.components.some(function (component) {
    return component.type === 'file';
  });
}
export function canShowFilePreview(formDefinition) {
  return canUploadFiles(formDefinition) || formDefinition.components.some(function (component) {
    return component.type === 'paymentframe';
  });
}
export function canAnswerQuestions(formDefinition) {
  var fieldComponents = formDefinition.components.filter(isFieldComponent);
  var nonFileComponents = fieldComponents.filter(function (component) {
    return component.type !== 'file';
  });
  return nonFileComponents.length > 0;
}
export function doesPageHaveType(_ref6) {
  var formDefinition = _ref6.formDefinition,
    pageNumber = _ref6.pageNumber,
    type = _ref6.type;
  return formDefinition.components.some(function (component) {
    return getComponentPage(component) === pageNumber && component.type === type;
  });
}
export function getComponentKeys(_ref7) {
  var formDefinition = _ref7.formDefinition,
    pageNumber = _ref7.pageNumber,
    type = _ref7.type;
  return formDefinition.components.filter(function (component) {
    return getComponentPage(component) === pageNumber && component.type === type;
  }).map(function (component) {
    return component.key;
  });
}
export function checkIsSinglePaymentFrame(formDefinition) {
  return formDefinition.components.length === 1 && formDefinition.components[0].type === 'paymentframe';
}